/*
 * @Author: bbqin
 * @Date: 2023-02-14 15:10:49
 * @LastEditTime: 2023-07-27 11:05:14
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\SmartCard\components\card\preLoad.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React, { Component } from "react";
import { loadJS } from '@platform/api';
import Skeleton from "../skeleton";
import EmptyPrompt from "../empty";

const BaseURL = '../../../../';

const getComponentNameSpace = path => {
    var s = path.split('/'),
        componentNameSpace;
    componentNameSpace = s.slice(s.length - 5).join('/');
    componentNameSpace.includes('.js') && (componentNameSpace = componentNameSpace.substring(0, componentNameSpace.length - 3));
    return componentNameSpace;
};

const handError = (src, error) => {
    error && error(src);
    console.error(`找不到${src}这个文件，请检查引用路径`);
};

const handleLoad = (componentNameSpace, async = false, success, error) => {
    try {
        if (!(async && componentNameSpace !== getComponentNameSpace(this.props.path))) {
            // this.setState({ component: window[componentNameSpace].default });
            success && success(window[componentNameSpace].default);
        } else {
            error && error(componentNameSpace);
        }
    } catch (e) {
        error && error(componentNameSpace);
        console.error(e.message);
        console.error(`请检查引用的${this.props.path}这个文件是源码还是编译好的。源码需要在config.json/buildEntryPath配相应的路径，编译好的则不用`);
    }
};

const createScript = (src, componentNameSpace, success, error) => {
    if (src) {
        // 完整地址
        if (src.includes(BaseURL)) {
            if (!componentNameSpace) {
                componentNameSpace = src.replace(BaseURL, '');
                componentNameSpace = componentNameSpace.replace('.js', '');
            }
            componentNameSpace = componentNameSpace.replace(BaseURL);
            if (window[componentNameSpace]) {
                let component = window[componentNameSpace].default;
                success && success(component);
            } else {
                // 加载js
                loadJS(
                    src,
                    () => {
                        try {
                            if (!window[componentNameSpace]) {
                                error && error(src);
                                console.error(`找不到全局对象，请检查引用文件${src}`);
                            } else {
                                let component = window[componentNameSpace].default;
                                success && success(component);
                            }
                        } catch (e) {
                            console.log(e);
                            error && error(src);
                        }
                    },
                    () => {
                        handError(src, error);
                    },
                );
            }
        } else {
            let scripts = Array.from(document.getElementsByTagName('script')),
                flag;
            componentNameSpace = getComponentNameSpace(src);
            flag = scripts.find(e => {
                return e.src.includes(componentNameSpace);
            });
            const loadEvent = handleLoad.bind(null, componentNameSpace, true, success, error);
            const errorEvent = handError.bind(null, src, error);
            if (window[componentNameSpace]) {
                // 已经加载过script标签
                handleLoad(componentNameSpace, false, success, error);
            } else {

                // 加载js
                let script;
                if (flag) {
                    script = flag;
                } else {
                    script = document.createElement('script');
                    script.src = BaseURL + componentNameSpace + '.js';
                    script.type = 'text/javascript';
                    document.body.appendChild(script);
                }
                script.addEventListener('load', loadEvent);
                script.addEventListener('error', errorEvent);

            }
        }
    }
};

export default createScript;
